/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// router setup
import router from './routes/router';

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '@ag-grid-community/client-side-row-model';
import '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/csv-export';
import { AgGridVue } from "@ag-grid-community/vue";
import "@ag-grid-enterprise/core";
import {LicenseManager} from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-064560}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Sembcorp_Solar_Singapore_Pte_Ltd}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Momens}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Momens}_need_to_be_licensed___{Momens}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{5_August_2025}____[v3]_[0102]_MTc1NDM0ODQwMDAwMA==db5c90c32600144275fca2fae7124ecc");

import { ModuleRegistry, RowClassRules, GridOptions } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";
import VCalendar from 'v-calendar';
import excel from "vue-excel-export";
import VueSmartWidget from 'vue-smart-widget'

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  ExcelExportModule,
  MasterDetailModule,
 //  LicenseManager
]);

Vue.use(VCalendar,{
  componentPrefix:'v',
});

Vue.use(excel);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueSmartWidget)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});
